import forms from './forms';
import icons from './site-icons';
import { SideNavBuilder } from './side-nav-builder';

export interface EntityEditorOptions {
	createCommand: () => any;
}

export class EntityEditor {
	public init (options: EntityEditorOptions) {
		icons.registerSiteIcons();
		this.buildSideNav();

		forms.makeFormPostCommand('#add-or-edit-form', options.createCommand,
			forms.displayServerRuleViolations, forms.redirectToLoginPage,
			forms.displayServerFailure, forms.focusOnFirstError);

		forms.formatFormHelpText();
	}

	private buildSideNav () {
		const sideNavBuilder = new SideNavBuilder();
		sideNavBuilder.render('.entity-data-container fieldset', '#side-nav-content');
	}
}

// add custom validation method
jQuery.validator.addMethod('customUrl', (value: any, element: any, options: any) : boolean => {
	const protocol = $(options).val();
	const testUrl = protocol + value;
	const $validator = jQuery.validator;
	return $validator.methods.url.call($validator.prototype, testUrl, element);
}, 'Please enter a valid URL.');
